/*@ngInject*/
const NavigationStateModel = function () {

    let stateModelStorage;

    this.init = function () {
        stateModelStorage = {};
    };

    this.saveViewState = function (stateName, param) {
        stateModelStorage[stateName] = _.cloneDeep(param);

    };

    this.updateViewStateData = function (stateName, param) {

        if (stateModelStorage[stateName]) {
            if (stateName === 'configuration.formTemplateBrowser') {
                stateModelStorage[stateName]['data'] = {uiFormTemplateId: _.cloneDeep(param)};
            }
        }

    };

    this.restoreViewState = function (stateName) {
        let previousState = stateModelStorage[stateName];

        if (previousState) {
            return stateModelStorage[stateName];
        }
    };

    this.init();
};

angular.module('umCore')
    .service('navigationStateModel', NavigationStateModel);
